import { SlideModal } from "../comparison_views/molecules/SlideModal";
import IconButton from "@mui/material/IconButton";
import {
  adaptClosingDateToRateLockOptions,
  BottomInputsWrapper,
  BottomText,
  BottomWrapper,
  InputsLeftWrapper,
  InputsWrapper,
  isFirstTimeHomebuyerOptions,
  LoanTypesMobileWrapper,
  lookingToOptions,
  occupancyTypeOptions,
  ProfileWrapper,
  propertyTypeOptions,
  rateLockOptions,
  RowLeftWrapper,
} from "./modal-utils";
import { ProfileIcon } from "../../atoms/icons/profile";
import { MobileIconWithTitle } from "../comparison_views/molecules/MobileIconWithTitle";
import { PropertyTypeIcon } from "../../atoms/icons/property-type";
import { StandardSelectWithError } from "../../atoms/StandardSelect";
import { OccupancyTypeIcon } from "../../atoms/icons/occupancy-type";
import { UsCitizenIcon } from "../../atoms/icons/us-citizen";
import { YesNoButtonsWithError } from "../comparison_views/molecules/YesNoButtons";
import { VaEligibleIcon } from "../../atoms/icons/va-eligible";
import { CreditScoreIcon } from "../../atoms/icons/credit-score";
import { SelfEmployedIcon } from "../../atoms/icons/self-employed";
import { WaiveEscrowIcon } from "../../atoms/icons/waive-escrow";
import { LoanOptionBlockSmall } from "../comparison_views/molecules/LoanOptionBlockSmall";
import { PropertyValueIcon } from "../../atoms/icons/property-value";
import { MoneyUnderlinedInput } from "../../atoms/MoneyUnderlinedInput";
import { DownpaymentIcon } from "../../atoms/icons/downpayment";
import { Box, Button, CircularProgress } from "@mui/material";
import { RefreshIcon } from "../../atoms/icons/refresh";
import React, { useState, useCallback } from "react";
import { styled } from "@mui/system";
import {
  FastTrackIcon,
  FastTrackSubtitle,
  FastTrackSubtitleWrapper,
  FastTrackTitle,
  FastTrackTitleWrapper,
} from "./DesktopSettingsModal";
import { RateLockPeriodIcon } from "../../atoms/icons/rate-lock-period";
import { doNothing } from "@mui/x-date-pickers/internals/utils/utils";
import { comparePageValidationObject } from "../../util/comparePageValidationSchema";
import { ModifyDataPointModal } from "../../molecules/ModifyDataPointModal";
import { CreditScoreUnderlinedInput } from "../../atoms/CreditScoreInput";
import { FastTrackAddressButton } from "../../atoms/FastTrackAddressButton";
import {
  CloseIconMobile,
  FormHelperStyledError,
} from "../comparison_views/molecules/ui-utils";

const RefreshButton = styled(Button)`
  border-radius: 20px;
  background-color: #00e09d;
  color: white;
  padding-left: 50px;
  padding-right: 50px;
  text-transform: none;
  max-width: 300px;
  flex: 1;
  font-family: proxima-nova, sans-serif;
  font-weight: bold;
  font-size: 16px;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 0px;
  left: 0px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: proxima-nova, sans-serif;
  font-size: 12px;
  height: 70px;
  width: 70px;
  background-color: #00000055;
  border-radius: 0;
  :hover {
    background-color: #00000055;
  }
`;

const MobileFastTrackIcon = styled(FastTrackIcon)`
  height: 15px;
`;

const MobileFastTrackSubtitle = styled(FastTrackSubtitle)`
  font-size: 10px;
`;

const MobileFastTrackTitle = styled(FastTrackTitle)`
  font-size: 24px;
`;

const FlexRowWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const MobileSettingsModal = ({
  isFastTrack,
  open,
  onClose,
  onFormEdit,
  lookingTo,
  formik,
  isRefinance,
  isRefinanceAndCashOut,
  isPurchase,
  isBuild,
  isLoading,
  isValid,
}) => {
  const [shouldShowAddressModal, setShouldShowAddressModal] = useState(false);

  const showAddressModal = useCallback(() => {
    setShouldShowAddressModal(true);
  }, [setShouldShowAddressModal]);

  const hideAddressModal = useCallback(() => {
    setShouldShowAddressModal(false);
  }, [setShouldShowAddressModal]);

  const addressButtonCopy =
    formik.values.street || formik.values.city || formik.values.state
      ? `${formik.values.street}, ${formik.values.city}, ${formik.values.state}`
      : "Enter an address";

  return (
    <SlideModal
      open={open}
      onClose={onClose}
      className="irq-modal-mobile"
      direction="left"
    >
      <div className="left-modal-wrapper">
        {!isFastTrack && (
          <CloseButton onClick={onClose}>
            <CloseIconMobile />
            Close
          </CloseButton>
        )}
        <FlexRowWrapper>
          <div className="right-justified">
            <ProfileWrapper>
              <ProfileIcon
                className="profile-icon-margin"
                fill="white"
                width={25}
                height={25}
              />
              Your Loan Profile
            </ProfileWrapper>

            {isFastTrack && (
              <>
                <FastTrackTitleWrapper>
                  <MobileFastTrackIcon src="/img/svg_icons/fast_track.svg" />
                  <MobileFastTrackTitle>
                    Instant Rate Quote
                  </MobileFastTrackTitle>
                </FastTrackTitleWrapper>
                <FastTrackSubtitleWrapper>
                  <MobileFastTrackSubtitle>
                    Fill in the information below to view today's loan options.
                  </MobileFastTrackSubtitle>
                </FastTrackSubtitleWrapper>
              </>
            )}

            <InputsWrapper>
              <MobileIconWithTitle>I am a:</MobileIconWithTitle>
              <StandardSelectWithError
                options={isFirstTimeHomebuyerOptions}
                name="isFirstTimeHomebuyer"
                value={formik.values.isFirstTimeHomebuyer}
                onChange={formik.handleChange}
                helperText={
                  formik.touched.isFirstTimeHomebuyer &&
                  formik.errors.isFirstTimeHomebuyer
                }
                error={
                  formik.touched.isFirstTimeHomebuyer &&
                  formik.errors.isFirstTimeHomebuyer
                }
              />
            </InputsWrapper>
            <InputsWrapper>
              <MobileIconWithTitle>Looking to:</MobileIconWithTitle>
              <StandardSelectWithError
                options={lookingToOptions}
                name="lookingTo"
                value={lookingTo}
                onChange={(...params) => {
                  onFormEdit(...params);
                  // required to force Formik to revalidate the field on change of context to Refinance
                  setTimeout(() => formik.validateForm(), 1);
                }}
              />
            </InputsWrapper>

            {(isPurchase || isBuild) && (
              <InputsWrapper>
                <MobileIconWithTitle>
                  <RateLockPeriodIcon fill="white" width={20} height={20} />
                  Rate Lock Period
                </MobileIconWithTitle>
                <StandardSelectWithError
                  options={rateLockOptions}
                  name="plannedClosingDate"
                  value={adaptClosingDateToRateLockOptions(
                    formik.values.plannedClosingDate
                  )}
                  onChange={formik.handleChange}
                  helperText={
                    formik.touched.plannedClosingDate &&
                    formik.errors.plannedClosingDate
                  }
                  error={
                    formik.touched.plannedClosingDate &&
                    formik.errors.plannedClosingDate
                  }
                  width={188}
                />
              </InputsWrapper>
            )}

            <InputsWrapper>
              <MobileIconWithTitle>
                <OccupancyTypeIcon width={20} height={20} />
                Occupancy Type
              </MobileIconWithTitle>
              <StandardSelectWithError
                options={occupancyTypeOptions}
                name="occupancyType"
                value={formik.values.occupancyType}
                onChange={formik.handleChange}
                helperText={
                  formik.touched.occupancyType && formik.errors.occupancyType
                }
                error={
                  formik.touched.occupancyType && formik.errors.occupancyType
                }
                width={188}
              />
            </InputsWrapper>

            <InputsWrapper>
              <MobileIconWithTitle>
                <UsCitizenIcon width={20} height={20} />
                US Citizen?
              </MobileIconWithTitle>
              <YesNoButtonsWithError
                values={[true, false]}
                value={formik.values.isUsCitizen}
                handleClick={(val) => {
                  formik.handleChange({
                    target: {
                      name: "isUsCitizen",
                      value: val,
                    },
                  });
                }}
                helperText={
                  formik.touched.isUsCitizen && formik.errors.isUsCitizen
                }
                error={formik.touched.isUsCitizen && formik.errors.isUsCitizen}
                isMobile
              />
            </InputsWrapper>

            {formik.values.occupancyType === "Primary" && (
              <InputsWrapper>
                <MobileIconWithTitle>
                  <VaEligibleIcon width={20} height={20} />
                  VA Eligible?
                </MobileIconWithTitle>
                <YesNoButtonsWithError
                  values={[true, false]}
                  value={formik.values.isVeteran}
                  handleClick={(val) => {
                    formik.handleChange({
                      target: {
                        name: "isVeteran",
                        value: val,
                      },
                    });
                  }}
                  helperText={
                    formik.touched.isVeteran && formik.errors.isVeteran
                  }
                  error={formik.touched.isVeteran && formik.errors.isVeteran}
                  isMobile
                />
              </InputsWrapper>
            )}

            {formik.values.isVeteran &&
              formik.values.occupancyType === "Primary" && (
                <>
                  <InputsWrapper>
                    <MobileIconWithTitle>
                      <VaEligibleIcon width={20} height={20} />
                      First VA Loan?
                    </MobileIconWithTitle>
                    <YesNoButtonsWithError
                      values={[true, false]}
                      value={formik.values.vaFirstTimeUse}
                      handleClick={(val) => {
                        formik.handleChange({
                          target: {
                            name: "vaFirstTimeUse",
                            value: val,
                          },
                        });
                      }}
                      helperText={
                        formik.touched.vaFirstTimeUse &&
                        formik.errors.vaFirstTimeUse
                      }
                      error={
                        formik.touched.vaFirstTimeUse &&
                        formik.errors.vaFirstTimeUse
                      }
                      isMobile
                    />
                  </InputsWrapper>

                  <InputsWrapper>
                    <MobileIconWithTitle>
                      <VaEligibleIcon width={20} height={20} />
                      Are you disabled?
                    </MobileIconWithTitle>
                    <YesNoButtonsWithError
                      values={[true, false]}
                      value={formik.values.disabledVeteran}
                      handleClick={(val) => {
                        formik.handleChange({
                          target: {
                            name: "disabledVeteran",
                            value: val,
                          },
                        });
                      }}
                      helperText={
                        formik.touched.disabledVeteran &&
                        formik.errors.disabledVeteran
                      }
                      error={
                        formik.touched.disabledVeteran &&
                        formik.errors.disabledVeteran
                      }
                      isMobile
                    />
                  </InputsWrapper>
                </>
              )}

            <InputsWrapper>
              <MobileIconWithTitle>
                <SelfEmployedIcon width={20} height={20} />
                Self-Employed?
              </MobileIconWithTitle>
              <YesNoButtonsWithError
                values={[true, false]}
                value={formik.values.isSelfEmployed}
                handleClick={(val) => {
                  formik.handleChange({
                    target: {
                      name: "isSelfEmployed",
                      value: val,
                    },
                  });
                }}
                helperText={
                  formik.touched.isSelfEmployed && formik.errors.isSelfEmployed
                }
                error={
                  formik.touched.isSelfEmployed && formik.errors.isSelfEmployed
                }
                isMobile
              />
            </InputsWrapper>

            <InputsWrapper>
              <MobileIconWithTitle>
                <WaiveEscrowIcon width={20} height={20} />
                Waive Escrow?
              </MobileIconWithTitle>
              <YesNoButtonsWithError
                values={["Yes", "No"]}
                value={formik.values.hasWaivedEscrow}
                handleClick={(val) => {
                  formik.handleChange({
                    target: {
                      name: "hasWaivedEscrow",
                      value: val,
                    },
                  });
                }}
                helperText={
                  formik.touched.hasWaivedEscrow &&
                  formik.errors.hasWaivedEscrow
                }
                error={
                  formik.touched.hasWaivedEscrow &&
                  formik.errors.hasWaivedEscrow
                }
                isMobile
              />
            </InputsWrapper>

            {isRefinanceAndCashOut && (
              <BottomInputsWrapper>
                <InputsLeftWrapper>
                  <RowLeftWrapper>
                    <DownpaymentIcon width={20} height={20} fill="white" />
                    Amount of Cash Out:
                  </RowLeftWrapper>
                  <div className="margin-left">
                    <MoneyUnderlinedInput
                      name="amountOfCashOut"
                      value={formik.values.amountOfCashOut}
                      onChange={formik.handleChange}
                      helperText={
                        formik.touched.amountOfCashOut &&
                        formik.errors.amountOfCashOut
                      }
                      error={
                        formik.touched.amountOfCashOut &&
                        formik.errors.amountOfCashOut
                      }
                    />
                  </div>
                </InputsLeftWrapper>
              </BottomInputsWrapper>
            )}

            <LoanTypesMobileWrapper>
              <div className="loan-types-wrapper">
                Loan Types
                <LoanOptionBlockSmall
                  showError={
                    !!formik.touched.loanOptions && !!formik.errors.loanOptions
                  }
                  loanOptions={formik.values.loanOptions}
                  customFormEdit={(name, value) =>
                    formik.handleChange({
                      target: {
                        name: "loanOptions",
                        value,
                      },
                    })
                  }
                />
              </div>
            </LoanTypesMobileWrapper>

            <BottomInputsWrapper>
              <Box>
                <FastTrackAddressButton
                  onClick={showAddressModal}
                  placeholder={addressButtonCopy}
                />
                {formik.touched.street && formik.errors.street && (
                  <FormHelperStyledError>
                    {formik.errors.street}
                  </FormHelperStyledError>
                )}
              </Box>

              <InputsLeftWrapper>
                <RowLeftWrapper>
                  <PropertyValueIcon width={20} height={20} fill="white" />
                  Property Value:
                </RowLeftWrapper>
                <div className="margin-left">
                  <MoneyUnderlinedInput
                    name="price"
                    value={formik.values.price}
                    onChange={formik.handleChange}
                    helperText={formik.touched.price && formik.errors.price}
                    error={formik.touched.price && formik.errors.price}
                  />
                </div>
              </InputsLeftWrapper>

              {(isPurchase || isBuild) && (
                <InputsLeftWrapper>
                  <RowLeftWrapper>
                    <DownpaymentIcon width={20} height={20} fill="white" />
                    Downpayment:
                  </RowLeftWrapper>
                  <div className="margin-left">
                    <MoneyUnderlinedInput
                      name="downPayment"
                      value={formik.values.downPayment}
                      onChange={formik.handleChange}
                      helperText={
                        formik.touched.downPayment && formik.errors.downPayment
                      }
                      error={
                        formik.touched.downPayment && formik.errors.downPayment
                      }
                      inputProps={{ max: formik.values.price, min: 0 }}
                    />
                  </div>
                </InputsLeftWrapper>
              )}

              {(isRefinance || isRefinanceAndCashOut) && (
                <InputsLeftWrapper>
                  <RowLeftWrapper>
                    <DownpaymentIcon width={20} height={20} fill="white" />
                    Loan Balance:
                  </RowLeftWrapper>
                  <div className="margin-left">
                    <MoneyUnderlinedInput
                      name="existingLoanBalance"
                      value={formik.values.existingLoanBalance}
                      onChange={formik.handleChange}
                      helperText={
                        formik.touched.existingLoanBalance &&
                        formik.errors.existingLoanBalance
                      }
                      error={
                        formik.touched.existingLoanBalance &&
                        formik.errors.existingLoanBalance
                      }
                    />
                  </div>
                </InputsLeftWrapper>
              )}

              <InputsLeftWrapper>
                <RowLeftWrapper>
                  <CreditScoreIcon width={20} height={20} fill="white" />
                  CreditScore:
                </RowLeftWrapper>
                <div className="margin-left">
                  <CreditScoreUnderlinedInput
                    name="creditScore"
                    placeholder="e.g. 700"
                    value={formik.values.creditScore}
                    onChange={formik.handleChange}
                    helperText={
                      formik.touched.creditScore && formik.errors.creditScore
                    }
                    error={
                      formik.touched.creditScore && formik.errors.creditScore
                    }
                  />
                </div>
              </InputsLeftWrapper>
            </BottomInputsWrapper>
          </div>
        </FlexRowWrapper>
        <BottomWrapper>
          {isLoading ? (
            <CircularProgress sx={{ color: "white" }} />
          ) : (
            <RefreshButton
              variant="contained"
              type="submit"
              onClick={formik.handleSubmit}
              startIcon={
                isFastTrack ? undefined : (
                  <RefreshIcon
                    fill={formik.isValid ? "white" : "#00000040"}
                    width={20}
                    height={20}
                  />
                )
              }
            >
              {isFastTrack ? "View Rates" : "Refresh Rates"}
            </RefreshButton>
          )}
          <BottomText>
            New loan options will be retrieved and your current loan comparison
            will reset
          </BottomText>
        </BottomWrapper>
        <ModifyDataPointModal
          open={shouldShowAddressModal}
          onClose={hideAddressModal}
          setFirstTimeBuyer={doNothing}
          data={{
            street: formik.values.street,
            city: formik.values.city,
            county: formik.values.county,
            state: formik.values.state,
            zip: formik.values.zip,
          }}
          openDataName="street"
          customFormEdit={doNothing}
          onFormEdit={doNothing}
          onSubmitAddress={(address) => {
            formik.setValues(
              {
                ...formik.values,
                street: address.street,
                city: address.city,
                county: address.county,
                countyFips: address.countyFips,
                state: address.state,
                stateFips: address.stateFips,
                zip: address.zip,
                propertyType: address.propertyType,
                neighborhood: address.neighborhood,
              },
              true
            );
          }}
          validationObject={comparePageValidationObject}
        />
      </div>
    </SlideModal>
  );
};
